/**
 * Run PMW main loader
 */

const main = async () => {

	require("./wpm/functions_main");
	require("./version.js");

	// Wait until jQuery is loaded
	await wpm.jQueryExists();

	// Wait until wpmDataLayer is loaded
	await wpm.wpmDataLayerFullyLoaded();

	/**
	 * Set webpack public path for chunk loading
	 * This ensures chunks load correctly even when scripts are combined/moved 
	 * by optimization plugins (SiteGround, Autoptimize, WP Rocket, etc.)
	 */
	if (wpmDataLayer?.general?.chunk_base_path) {
		// eslint-disable-next-line no-undef, camelcase
		__webpack_public_path__ = wpmDataLayer.general.chunk_base_path;
	}

	// wait 1000ms
	// await new Promise(resolve => setTimeout(resolve, 1000))

	// Load all essential scripts first
	require("./wpm/functions_loader");
	
	// Load new event filtering system
	require("./wpm/hooks");
	require("./wpm/pixel-registry");
	require("./wpm/event-processor");

	// Initialize command queue early so filters can be registered before events fire
	wpm.initializeCommandQueue();

	// Output PMW console message
	wpm.pmwConsoleMessage();

	// Load the consent management module as a chunk
	await wpm.loadConsentModule();
	await wpm.consent.load();

	// Doesn't work if we listen to pmw:dom:ready because it runs too late
	// (at the end of the main.js file)
	// TODO: Find out why that order is important and optimize it. It is also difficult to test. In Cypress it works just with "pmw:dom:ready"
	jQuery(() => {
		require("./wpm/event_listeners_on_ready");
	});

	// Load remaining event listeners
	require("./wpm/event_listeners");
	
	// Load doofinder listener as a chunk
	import(/* webpackChunkName: "doofinder-listener" */ "./wpm/listeners/doofinder");

	wpm.loadWcHooksFunctions();

	// Check if domain is excluded from tracking
	// If so, return
	if (wpm.excludeDomainFromTracking()) return;

	// Load pixels dynamically based on configuration
	const pixelLoaders = [];

	// Load free pixels conditionally
	if (wpmDataLayer?.pixels?.google) {
		pixelLoaders.push(
			import(/* webpackChunkName: "pixel-google" */ "./pixels/google/loader")
		);
	}
	
	if (wpmDataLayer?.pixels?.facebook) {
		pixelLoaders.push(
			import(/* webpackChunkName: "pixel-facebook" */ "./pixels/facebook/loader")
		);
	}
	
	if (wpmDataLayer?.pixels?.hotjar) {
		pixelLoaders.push(
			import(/* webpackChunkName: "pixel-hotjar" */ "./pixels/hotjar/loader")
		);
	}

	// #if process.env.TIER === 'premium'
// 	/**
// 	 *  Load premium pixels conditionally
// 	 */
// 	if (wpm.canLoadPremiumFeatures()) {
// 		pixelLoaders.push(
// 			import(/* webpackChunkName: "wpm-premium-events" */ "./wpm/event_listeners_premium")
// 		);
// 
// 		if (wpmDataLayer?.pixels?.adroll) {
// 			pixelLoaders.push(
// 				import(/* webpackChunkName: "pixel-adroll" */ "./pixels/adroll/loader")
// 			);
// 		}
// 		
// 		if (wpmDataLayer?.pixels?.linkedin) {
// 			pixelLoaders.push(
// 				import(/* webpackChunkName: "pixel-linkedin" */ "./pixels/linkedin/loader")
// 			);
// 		}
// 		
// 		if (wpmDataLayer?.pixels?.bing) {
// 			pixelLoaders.push(
// 				import(/* webpackChunkName: "pixel-microsoft" */ "./pixels/microsoft-ads/loader")
// 			);
// 		}
// 		
// 		if (wpmDataLayer?.pixels?.outbrain) {
// 			pixelLoaders.push(
// 				import(/* webpackChunkName: "pixel-outbrain" */ "./pixels/outbrain/loader")
// 			);
// 		}
// 		
// 		if (wpmDataLayer?.pixels?.pinterest) {
// 			pixelLoaders.push(
// 				import(/* webpackChunkName: "pixel-pinterest" */ "./pixels/pinterest/loader")
// 			);
// 		}
// 		
// 		if (wpmDataLayer?.pixels?.snapchat) {
// 			pixelLoaders.push(
// 				import(/* webpackChunkName: "pixel-snapchat" */ "./pixels/snapchat/loader")
// 			);
// 		}
// 		
// 		if (wpmDataLayer?.pixels?.taboola) {
// 			pixelLoaders.push(
// 				import(/* webpackChunkName: "pixel-taboola" */ "./pixels/taboola/loader")
// 			);
// 		}
// 		
// 		if (wpmDataLayer?.pixels?.tiktok) {
// 			pixelLoaders.push(
// 				import(/* webpackChunkName: "pixel-tiktok" */ "./pixels/tiktok/loader")
// 			);
// 		}
// 		
// 		if (wpmDataLayer?.pixels?.twitter) {
// 			pixelLoaders.push(
// 				import(/* webpackChunkName: "pixel-twitter" */ "./pixels/twitter/loader")
// 			);
// 		}
// 		
// 		if (wpmDataLayer?.pixels?.reddit) {
// 			pixelLoaders.push(
// 				import(/* webpackChunkName: "pixel-reddit" */ "./pixels/reddit/loader")
// 			);
// 		}
// 		
// 		if (wpmDataLayer?.pixels?.vwo) {
// 			pixelLoaders.push(
// 				import(/* webpackChunkName: "pixel-vwo" */ "./pixels/vwo/loader")
// 			);
// 		}
// 	}
	// #endif

	// Load all active pixels in parallel
	await Promise.all(pixelLoaders);

	/** Load the deprecated functions as a chunk (if enabled) */
	if (wpmDataLayer?.general?.modules?.load_deprecated_functions !== false) {
		const {loadDeprecatedFunctions} = await import(/* webpackChunkName: "deprecated-functions" */ "./wpm/deprecated.mjs");
		loadDeprecatedFunctions();
	}

	// Preload pixels
	document.dispatchEvent(new Event("pmw:load-pixels"));

	// Trigger wpmLoad event
	document.dispatchEvent(new Event("wpmLoad"));

	// Wait until page is loaded
	await wpm.pageLoaded();

	document.dispatchEvent(new Event("pmw:ready"));
	wpm.triggerPmwDomReadyEvent();

	// Check if the library version matches the PMW version that's installed on the server
	wpm.checkLibraryVersion();
};

main();








